import React from "react";
import NavItems from "./nav-items";

const NavbarDesktop = () => {
  const [openNav, setOpenNav] = React.useState(false);

  return (
    <div className="flex w-full">
      <div className="flex justify-between w-full items-center py-2 border-b border-primaryBorder px-4 backdrop-blur-sm z-20">
        <div className="px-4 pb-2">
          <div className="relative top-3 left-0 group transition duration-300 h-16 overflow-visible cursor-pointer">
            <div className="border-l-2 border-t-2 border-lightBorder h-10 w-56 group-hover:h-16 group-hover:w-64 transition-all duration-500 bg-transparent">
              <h1 className="text-white absolute top-3 left-8 font-bold">
                Your Tech Company
              </h1>
            </div>
            <div className="absolute bottom-4 -right-4 border-b-2 border-r-2 border-lightBorder h-10 w-56 group-hover:h-16 group-hover:w-64 transition-all duration-500 bg-transparent group-hover:right-4"></div>
          </div>
        </div>
        <div className="hidden lg:flex gap-6 items-center">
          <NavItems />
        </div>
        <div
          className="lg:hidden cursor-pointer"
          onClick={() => setOpenNav(!openNav)}
        >
          {openNav ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              className="h-6 w-6"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </div>
      </div>
      <div
        className={`z-10 lg:hidden absolute top-[89px] left-0 w-full py-8 flex justify-center backdrop-blur duration-500 border-b border-primaryBorder ${
          openNav ? "translate-y-0" : "translate-y-[-460px]"
        }`}
      >
        <NavItems />
      </div>
    </div>
  );
};

export default NavbarDesktop;
